import { render, staticRenderFns } from "./StudentMediumCourses.vue?vue&type=template&id=d2087fdc&scoped=true&"
import script from "./StudentMediumCourses.vue?vue&type=script&lang=js&"
export * from "./StudentMediumCourses.vue?vue&type=script&lang=js&"
import style0 from "./StudentMediumCourses.vue?vue&type=style&index=0&id=d2087fdc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2087fdc",
  null
  
)

export default component.exports